import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const MedicationsFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.MEDICATIONS)}>
      <FormItem
        label={<Text>{t(supConstants.TABLETS_IN)}</Text>}
        name="preferredAdminRoute"
        colon={false}
      >
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.PREFERRED_DRINK)}</Text>}
        name="preferredDrink"
      >
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.PRN_MEDS)}</Text>}
        name="prnMedsNote"
      >
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
    </FormCard>
  )
}
